/* eslint-disable import/no-cycle */
import React from 'react';

import FilePreview from './FilePreview';
import * as fileTypes from '../../constants/fileTypes';
import DownloadButton from './DownloadButtonWrapper';
import {
  getLinkTextFromServerText,
  getNameFromLinkText,
  getFileURL,
  addAttributeToUrls,
  getFilePreviewType,
  getClassNameFromTag,
} from './utils'
import { ErrorIcon } from '../../../../../components/icons/index';
import { BaseMessage, MessageParamsInput } from '../'
import { MessageSubtypes } from '../../constants'
import { MessageSubtype } from '../../models/MessageParams'; 

import './FileMessage.scss';

export interface FileMessageInput extends MessageParamsInput {
  file: File | null;
  filename: string | null;
}

const PREFIX_FOR_OPENING_FILE = '?open=true';

class FileMessage extends BaseMessage {
  readonly subtype: Extract<MessageSubtype,
    typeof MessageSubtypes.FILE | typeof MessageSubtypes.FILE_UPLOAD>;

  fileUrl!: string;
  filePreviewType!: string;
  linkText!: string;
  linkClassName!: string;
  name!: string;
  openUrl!: string;
  isBlockedByServer!: boolean;
  file: File | null;
  filename: string | null;

  constructor(messageParamsInput: FileMessageInput) {
    super(messageParamsInput);

    this.subtype = (messageParamsInput.subtype as typeof this.subtype) || MessageSubtypes.FILE;
    this.fileUrl = getFileURL(this.text);
    this.filePreviewType = getFilePreviewType(this.fileUrl);
    this.linkText = getLinkTextFromServerText(this.text);
    this.linkClassName = getClassNameFromTag(this.text)
    this.name = getNameFromLinkText(this.linkText);
    this.openUrl = `${this.fileUrl}${PREFIX_FOR_OPENING_FILE}`;
    this.isBlockedByServer = this.text.indexOf('msg-file-transfer-blocked-url') !== -1;
    this.file = messageParamsInput.file || null
    this.filename = messageParamsInput.filename || null

    this.renderText = this.renderText.bind(this)
  }

  renderText() {
    const isError = this.isBlockedByServer;
    const text = this.filePreviewType !== fileTypes.AUDIO && this.filePreviewType !== fileTypes.VIDEO
      ? (
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: addAttributeToUrls(this.text, PREFIX_FOR_OPENING_FILE) }}
        />
      )
      : (
        <a
          href={this.openUrl}
          download={this.name}
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.linkText}
        </a>
      );

    return (
      <div
        className={`message-text-wrapper ${this.filePreviewType || ''}`}
      >
        <div className="file-message-wraper">
          <div className={`file-message ${this.filePreviewType} ${isError ? 'file-error' : ''}`}>
            <span className="file-name">
              {isError && <ErrorIcon />}
              {text}
            </span>

            {this.filePreviewType
              && (
              <FilePreview
                type={this.filePreviewType}
                url={this.openUrl}
                text={this.text}
                name={this.name}
              />
              )}

          </div>

          {!isError && <DownloadButton src={this.fileUrl} fileName={this.name} className={this.linkClassName}/>}
        </div>
      </div>
    );
  }
}

export default FileMessage;
